import React from "react";
import {
  TracingWrapper,
  MapViewProcessingContainer,
  AnimatedIconContainer,
  ProcessingIconBox,
  MapViewProcessingTitle,
  MapViewSubtitle,
  MapViewDescription,
  MapViewTitleDescriptionBox,
  MapViewProgressBox,
  MapViewProcessingStepsBox,
  MapViewProcessingStep,
  MapViewStepIcon,
  MapViewQuoteCard,
  MapViewCaption,
  MapViewQuoteText,
  MapViewStepLabel,
  MapViewLinearProgress,
  MapViewIntegratedOrderDetails,
  MapViewOrderDetailsTitle,
  MapViewOrderDetailsContainer,
  OrderInfoRow,
  OrderInfoLabel,
  OrderInfoValue,
} from "layout/styles";
import { Divider, Box } from "@mui/material";
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ReceiptIcon from '@mui/icons-material/Receipt';
import StorefrontIcon from '@mui/icons-material/Storefront';

const ProcessingOrderView = ({ orderInfo = {} }) => {
  return (
    <TracingWrapper>
      <MapViewProcessingContainer>
        {/* Animated Processing Icon */}
        <AnimatedIconContainer>
          <ProcessingIconBox>
            <HourglassEmptyIcon sx={{ 
              fontSize: 50, 
              color: 'white',
              animation: 'rotate 3s linear infinite',
              '@keyframes rotate': {
                '0%': { transform: 'rotate(0deg)' },
                '100%': { transform: 'rotate(360deg)' }
              }
            }} />
          </ProcessingIconBox>
        </AnimatedIconContainer>

        {/* Title and Description */}
        <MapViewTitleDescriptionBox>
          <MapViewProcessingTitle variant="h3">
            Order Processing
          </MapViewProcessingTitle>
          
          <MapViewSubtitle variant="h6">
            Your order is currently being processed
          </MapViewSubtitle>

          <MapViewDescription variant="body1">
            Please stay on this page for real-time updates
          </MapViewDescription>
        </MapViewTitleDescriptionBox>

        {/* Progress Indicator */}
        <MapViewProgressBox>
          <MapViewLinearProgress />
          <MapViewCaption variant="caption">
            Processing your order...
          </MapViewCaption>
        </MapViewProgressBox>

        {/* Processing Steps */}
        <MapViewProcessingStepsBox>
          <MapViewProcessingStep className="step-1">
            <MapViewStepIcon variant="completed">
              <RestaurantIcon sx={{ color: 'success.main', fontSize: 24 }} />
            </MapViewStepIcon>
            <MapViewStepLabel variant="caption" sx={{ color: 'success.main', fontWeight: 600 }}>
              Order Placed
            </MapViewStepLabel>
          </MapViewProcessingStep>

          <MapViewProcessingStep className="step-2">
            <MapViewStepIcon variant="processing">
              <HourglassEmptyIcon sx={{ color: 'warning.main', fontSize: 24 }} />
            </MapViewStepIcon>
            <MapViewStepLabel variant="caption" sx={{ color: 'warning.main', fontWeight: 600 }}>
              Processing
            </MapViewStepLabel>
          </MapViewProcessingStep>

          <MapViewProcessingStep className="step-3">
            <MapViewStepIcon variant="pending">
              <LocalShippingIcon sx={{ color: 'text.disabled', fontSize: 24 }} />
            </MapViewStepIcon>
            <MapViewStepLabel variant="caption" sx={{ color: 'text.disabled', fontWeight: 600 }}>
              On the way
            </MapViewStepLabel>
          </MapViewProcessingStep>
        </MapViewProcessingStepsBox>

        {/* Thank you message */}
        <MapViewQuoteCard>
          <MapViewQuoteText variant="body2">
            "Thank you for your patience! We'll notify you as soon as your order is ready."
          </MapViewQuoteText>
        </MapViewQuoteCard>
          <MapViewIntegratedOrderDetails>
            <MapViewOrderDetailsTitle variant="h6">
              Order Details
            </MapViewOrderDetailsTitle>
            
            <MapViewOrderDetailsContainer>
              <OrderInfoRow>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <ReceiptIcon sx={{ color: 'primary.main', fontSize: 18 }} />
                  <OrderInfoLabel>Order Number</OrderInfoLabel>
                </Box>
                <OrderInfoValue data-type="order-number">
                  #{orderInfo?.number || 'N/A'}
                </OrderInfoValue>
              </OrderInfoRow>

              <Divider sx={{ my: 0.5 }} />

              <OrderInfoRow>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <StorefrontIcon sx={{ color: 'primary.main', fontSize: 18 }} />
                  <OrderInfoLabel>Restaurant</OrderInfoLabel>
                </Box>
                <OrderInfoValue>
                  {orderInfo?.companyName || 'N/A'}
                </OrderInfoValue>
              </OrderInfoRow>

              <Divider sx={{ my: 0.5 }} />

              <OrderInfoRow>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <LocationOnIcon sx={{ color: 'primary.main', fontSize: 18 }} />
                  <OrderInfoLabel>Delivery Address</OrderInfoLabel>
                </Box>
                <OrderInfoValue sx={{ 
                  maxWidth: '300px',
                  fontSize: '16px'
                }}>
                  {orderInfo?.address || 'N/A'}
                </OrderInfoValue>
              </OrderInfoRow>
            </MapViewOrderDetailsContainer>
          </MapViewIntegratedOrderDetails>
      </MapViewProcessingContainer>
    </TracingWrapper>
  );
};

export default ProcessingOrderView; 